import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";

const MAX_ATTEMPTS = 3;
const BLOCK_DURATION = 30; // segundos

const Login = ({ onLogin, onForgotPassword }) => {
    const [user, setUser] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    // Estado para bloqueo
    const [attempts, setAttempts] = useState(0);
    const [isBlocked, setIsBlocked] = useState(false);
    const [timeLeft, setTimeLeft] = useState(0);

    useEffect(() => {
        let timer;
        if (isBlocked && timeLeft > 0) {
            timer = setInterval(() => {
                setTimeLeft((prev) => prev - 1);
            }, 1000);
        } else if (timeLeft === 0 && isBlocked) {
            setIsBlocked(false);
            setAttempts(0);
        }
        return () => clearInterval(timer);
    }, [isBlocked, timeLeft]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isBlocked) return;

        setIsLoading(true);
        setError("");

        try {
            const response = await axios.post(
                //"https://helpharmadomicilios.cielum.co/webhook-test/PRO-c5d7c5ed-04d1-43f3-be13-63a51be41a7a", //TEST
                "https://helpharmadomicilios.cielum.co/webhook/PRO-c5d7c5ed-04d1-43f3-be13-63a51be41a7a", //produccion
                {
                    user: user,
                    password: password
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                    auth: {
                        username: "DOMICILIOSAPI_operador_logistico",
                        password: "DOMICILIOSAPI_operador_logistico"
                    }
                }
            );

            const data = response.data;

            if (data && (data.error === 1 || data.error === "1")) {
                throw new Error(data.message || "Error de credenciales");
            }

            const userData = {
                email: user,
                name: data.name || user,
                role: data.role || "Admin"
            };

            onLogin(userData);

        } catch (err) {
            console.error("Error Login:", err);
            const newAttempts = attempts + 1;
            setAttempts(newAttempts);

            let msg = err.message || "Error en el servidor";
            if (err.response && err.response.data && err.response.data.message) {
                msg = err.response.data.message;
            }

            setError(msg);

            if (newAttempts >= MAX_ATTEMPTS) {
                setIsBlocked(true);
                setTimeLeft(BLOCK_DURATION);
                setError(`Demasiados intentos fallidos. Bloqueado por ${BLOCK_DURATION} segundos.`);
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="auth-background">
            <div className="glass-card-auth">
                {/* Logo */}
                <div className="auth-logo">🏥</div>
                <h3 className="auth-title">Admin Domicilios</h3>
                <p className="auth-subtitle">Ingresa tus credenciales para continuar</p>

                {error && (
                    <div className="alert alert-danger" style={{ fontSize: '0.85rem' }}>
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="input-group-premium">
                        <label className="input-label">Usuario (Correo)</label>
                        <span className="input-icon">✉️</span>
                        <input
                            type="email"
                            className="form-control input-premium"
                            value={user}
                            onChange={(e) => setUser(e.target.value)}
                            required
                            disabled={isBlocked || isLoading}
                            placeholder="tu@correo.com"
                        />
                    </div>
                    <div className="input-group-premium">
                        <label className="input-label">Contraseña</label>
                        <span className="input-icon">🔒</span>
                        <input
                            type="password"
                            className="form-control input-premium"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            disabled={isBlocked || isLoading}
                            placeholder="••••••••"
                        />
                    </div>

                    <button
                        type="submit"
                        className="btn btn-premium w-100 mb-3"
                        disabled={isBlocked || isLoading}
                        style={{ marginTop: '0.5rem' }}
                    >
                        {isBlocked
                            ? `⏳ Espere ${timeLeft}s...`
                            : isLoading
                                ? <><span className="spinner-premium"></span>Verificando...</>
                                : "Ingresar"
                        }
                    </button>

                    <div className="text-center">
                        <button
                            type="button"
                            className="btn btn-link"
                            onClick={onForgotPassword}
                            disabled={isBlocked || isLoading}
                        >
                            ¿Olvidaste tu contraseña?
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Login;
